module.exports = __webpack_public_path__ + "static/media/2.8c202b49.jpg";